const ServiceBoxImage3 = () => (
  <svg
    width="129"
    height="134"
    viewBox="0 0 129 134"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1668_736)">
      <path
        d="M0 16C0 7.16345 7.16344 0 16 0H113C121.837 0 129 7.16344 129 16V118C129 126.837 121.837 134 113 134H16C7.16344 134 0 126.837 0 118V16Z"
        fill="#010D25"
      />
      <path
        opacity="0.5"
        d="M52.6857 52.0117L54.1636 52.0117C60.791 52.0117 66.1635 46.6391 66.1635 40.0117L66.1635 35.5691C66.1635 28.9416 71.5361 23.5691 78.1635 23.5691L106.843 23.5691"
        stroke="url(#paint0_linear_1668_736)"
        strokeLinecap="round"
      />
      <path
        opacity="0.5"
        d="M52.6857 82.2656L54.1636 82.2656C60.791 82.2656 66.1635 87.6382 66.1635 94.2656L66.1635 97.7718C66.1635 104.399 71.5361 109.772 78.1635 109.772L106.843 109.772"
        stroke="url(#paint1_linear_1668_736)"
        strokeLinecap="round"
      />
      <path
        d="M56.9828 64.7014L69.4273 64.7014C72.9314 64.7014 75.7721 61.8607 75.7721 58.3565V58.3565C75.7721 54.8524 78.6128 52.0117 82.117 52.0117L99.1169 52.0117"
        stroke="url(#paint2_linear_1668_736)"
        strokeLinecap="round"
      />
      <path
        d="M56.9828 72.1245L70.7016 72.1245C73.502 72.1245 75.7721 74.3947 75.7721 77.1951V77.1951C75.7721 79.9954 78.0423 82.2656 80.8427 82.2656L99.1169 82.2656"
        stroke="url(#paint3_linear_1668_736)"
        strokeLinecap="round"
      />
      <circle
        cx="104.831"
        cy="23.8311"
        r="2.79354"
        fill="url(#paint4_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="23.8315"
        r="5.21407"
        stroke="url(#paint5_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="52.6102"
        r="2.79354"
        fill="url(#paint6_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="52.6103"
        r="5.21407"
        stroke="url(#paint7_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="81.3892"
        r="2.79354"
        fill="url(#paint8_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="81.3894"
        r="5.21407"
        stroke="url(#paint9_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="110.168"
        r="2.79354"
        fill="url(#paint10_linear_1668_736)"
      />
      <circle
        cx="104.831"
        cy="110.168"
        r="5.21407"
        stroke="url(#paint11_linear_1668_736)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1664 60.0591H46.1043C47.3159 60.0591 48.2981 61.0413 48.2981 62.2529V75.4156C48.2981 76.6272 47.3159 77.6094 46.1043 77.6094H24.1664C22.9548 77.6094 21.9727 76.6272 21.9727 75.4156V62.2529C21.9727 61.0413 22.9548 60.0591 24.1664 60.0591Z"
        stroke="url(#paint12_linear_1668_736)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.554 73.2218H41.7167"
        stroke="url(#paint13_linear_1668_736)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2633 55.6715H45.0074"
        stroke="url(#paint14_linear_1668_736)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.554 51.2838H41.7167"
        stroke="url(#paint15_linear_1668_736)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g style={{ mixBlendMode: 'plus-lighter' }}>
        <g filter="url(#filter0_f_1668_736)">
          <path
            d="M53.8765 62.4785C17.3899 79.262 -56.4496 60.4132 -70.4256 30.0297C-84.4017 -0.353791 -66.1532 -38.5901 -29.6665 -55.3736C6.82015 -72.157 47.7283 -61.132 61.7043 -30.7485C75.6804 -0.365045 90.3632 45.6951 53.8765 62.4785Z"
            fill="#01369C"
          />
        </g>
        <g filter="url(#filter1_f_1668_736)">
          <path
            d="M27.7243 25.2503C10.2769 33.2758 -24.7567 24.861 -31.2479 10.7492C-37.7392 -3.36263 -28.8576 -21.3085 -11.4102 -29.3341C6.03715 -37.3597 25.4433 -32.4258 31.9345 -18.314C38.4258 -4.20218 45.1717 17.2247 27.7243 25.2503Z"
            fill="#006BF8"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_1668_736"
        x="-115.125"
        y="-103.22"
        width="231.925"
        height="211.988"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="20"
          result="effect1_foregroundBlur_1668_736"
        />
      </filter>
      <filter
        id="filter1_f_1668_736"
        x="-63.3727"
        y="-63.1824"
        width="132.204"
        height="121.55"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="15"
          result="effect1_foregroundBlur_1668_736"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1668_736"
        x1="100.53"
        y1="27.4107"
        x2="56.766"
        y2="27.4107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" stopOpacity="0" />
        <stop offset="0.46" stopColor="#5EA6FF" />
        <stop offset="1" stopColor="#5EA6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1668_736"
        x1="100.53"
        y1="106.057"
        x2="56.766"
        y2="106.057"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" stopOpacity="0" />
        <stop offset="0.46" stopColor="#5EA6FF" />
        <stop offset="1" stopColor="#5EA6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1668_736"
        x1="95.1472"
        y1="54.2503"
        x2="56.9828"
        y2="54.2503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" stopOpacity="0" />
        <stop offset="0.46" stopColor="#5EA6FF" />
        <stop offset="1" stopColor="#5EA6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1668_736"
        x1="95.1472"
        y1="80.4766"
        x2="56.9828"
        y2="80.4766"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" stopOpacity="0" />
        <stop offset="0.46" stopColor="#5EA6FF" />
        <stop offset="1" stopColor="#5EA6FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1668_736"
        x1="102.037"
        y1="23.8311"
        x2="107.624"
        y2="23.8311"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1668_736"
        x1="99.1168"
        y1="23.8315"
        x2="110.545"
        y2="23.8315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1668_736"
        x1="102.037"
        y1="52.6102"
        x2="107.624"
        y2="52.6102"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1668_736"
        x1="99.1168"
        y1="52.6103"
        x2="110.545"
        y2="52.6103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1668_736"
        x1="102.037"
        y1="81.3892"
        x2="107.624"
        y2="81.3892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1668_736"
        x1="99.1168"
        y1="81.3894"
        x2="110.545"
        y2="81.3894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1668_736"
        x1="102.037"
        y1="110.168"
        x2="107.624"
        y2="110.168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1668_736"
        x1="99.1168"
        y1="110.168"
        x2="110.545"
        y2="110.168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1668_736"
        x1="21.9727"
        y1="68.8342"
        x2="48.2981"
        y2="68.8342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1668_736"
        x1="28.554"
        y1="73.2218"
        x2="41.7167"
        y2="73.2218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1668_736"
        x1="25.2633"
        y1="55.6715"
        x2="45.0074"
        y2="55.6715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1668_736"
        x1="28.554"
        y1="51.2838"
        x2="41.7167"
        y2="51.2838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_1668_736">
        <path
          d="M0 16C0 7.16345 7.16344 0 16 0H113C121.837 0 129 7.16344 129 16V118C129 126.837 121.837 134 113 134H16C7.16344 134 0 126.837 0 118V16Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ServiceBoxImage3;
